import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 80px);
    min-height: unset !important;
    padding: 0 20px;

    @media (min-width: 1600px) {
        max-width: 1600px;
        margin: auto;
    }
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
`

export const PageTitle = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 48px;
    font-weight: 700;
    margin: 0;
    margin-bottom: 1.5rem;
`

export const TitleBox = styled.div`
    width: 100%;
    height: fit-content;
    align-items: center;
    background-color: rgba(226, 232, 240, 0.9);
    margin-bottom: 2rem;
`

export const ShowTitle = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 36px;
    font-weight: 500;
    padding: 2rem;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
`

export const ScanMessageWrapper = styled.div`
    width: 100%;
    text-align: center;
    padding: 1rem 0;
`

export const ScanMessage = styled.p<{ success: boolean }>`
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    margin-top: 0rem;
    margin-bottom: 1rem;
    color: ${({ success }) => (success ? '#00830D' : '#CE0000')};
`

export const TicketDataLabel = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
`
